export const arabicCurrencies = ['SAR', 'AED', 'KWD', 'OMR', 'QAR']
export const arabicSymbols = {
    SAR: '⃀',
    AED: 'درهم',
    EGP: 'جنيه مصري',
    KWD: 'دينار',
    OMR: 'ريال',
    QAR: 'ريال ق'
}
